// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBfe0uiw50gn8TaqKpzMtT3OzNLSxZyZeU",
  authDomain: "kkptraders-8ef96.firebaseapp.com",
  projectId: "kkptraders-8ef96",
  storageBucket: "kkptraders-8ef96.firebasestorage.app",
  messagingSenderId: "429397125623",
  appId: "1:429397125623:web:c8d065f93200a2537be6f2",
  measurementId: "G-VSBQTNJ1P2"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export {app, auth, analytics, db};